import React from "react";
import {
  Alert,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
  Checkbox,
  InputNumber,
} from "antd";

import get from "lodash/get";
import filter from "lodash/filter";
import { connect } from "react-redux";

import classes from "./SettingsPatientEventForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {
  createMilestoneEvent,
  getUnassignedEvents,
  linkFormsToPatientEvent,
  updateMilestoneEvents,
} from "../../api/requests";

class SettingsMilestonesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      unassignedEvents: [],
      requestResult: {},
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getUnassignedEvents();
      this.setState({ unassignedEvents: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          const { data } = this.props.id
            ? await updateMilestoneEvents({
                id: this.props.id,
                name: values.name,
                tracking_patient_event: values.tracking_patient_event,
                hide_if_pending: values.hide_if_pending,
                order_index: values.order_index,
                show_on_patient_page: values.show_on_patient_page,
                requires_validation: values.requires_validation,
                track_in_finance: values.track_in_finance,
                events: [
                  ...this.state.unassignedEvents,
                  ...(this.props.events || []),
                ]
                  .filter((item) => values.events.includes(item.id))
                  .map((item) => item.id),
              })
            : await createMilestoneEvent({
                name: values.name,
                codename: values.codename,
                state: values.state,
                tracking_patient_event: values.tracking_patient_event,
                hide_if_pending: values.hide_if_pending,
                order_index: values.order_index,
                show_on_patient_page: values.show_on_patient_page,
                requires_validation: values.requires_validation,
                track_in_finance: values.track_in_finance,
                events: [
                  ...this.state.unassignedEvents,
                  ...(this.props.events || []),
                ]
                  .filter((item) => values.events.includes(item.id))
                  .map((item) => item.id),
              });

          // await linkFormsToPatientEvent({
          //   id: data.id,
          //   data: this.state.forms
          //     .filter((item) => values.form_events.includes(item.id))
          //     .map((item) => ({ form_id: item.id })),
          // });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );

            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { isPredefined } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t("NamespaceSettingsMilestonesForm:Milestone")}
          </h4>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                <b>
                  {this.props.i18n.t(
                    "NamespaceSettingsMilestonesForm:Milestone name"
                  )}
                  :
                </b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name"),
                  })(<Input type="text" disabled={isPredefined} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <b>
                  {this.props.i18n.t("NamespaceSettingsMilestonesForm:Events")}:
                </b>
                <Form.Item>
                  {getFieldDecorator("events", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "events", []).map(
                      (item) => item.id
                    ),
                  })(
                    <Select mode="multiple" disabled={isPredefined}>
                      {[
                        ...this.state.unassignedEvents,
                        ...(this.props.events || []),
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <Form.Item>
                <b>
                  {this.props.i18n.t("NamespaceSettingsMilestonesForm:Order")}:
                </b>
                {getFieldDecorator("order_index", {
                  initialValue: get(this.props, "order_index", 0),
                })(<InputNumber />)}
              </Form.Item>
            </Col>

            <Col span={24}>
              <label>
                {getFieldDecorator("show_on_patient_page", {
                  initialValue: get(this.props, "show_on_patient_page", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsMilestonesForm:Show on patient page"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("tracking_patient_event", {
                  initialValue: get(
                    this.props,
                    "tracking_patient_event",
                    false
                  ),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsMilestonesForm:Tracking Patient Events"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("hide_if_pending", {
                  initialValue: get(this.props, "hide_if_pending", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsMilestonesForm:Hide event if pending."
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
            <Col span={24}>
              <label>
                {getFieldDecorator("track_in_finance", {
                  initialValue: get(this.props, "track_in_finance", false),
                  valuePropName: "checked",
                })(
                  <Checkbox>
                    {this.props.i18n.t(
                      "NamespaceSettingsMilestonesForm:Track in finance"
                    )}
                  </Checkbox>
                )}
              </label>
            </Col>
          </Row>

          <br />

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            }

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {isPredefined
                ? this.props.i18n.t("Close")
                : this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "SettingsMilestonesForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsMilestonesForm))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsPatientEvents/SettingsMilestonesForm.js